import { useState, useEffect } from "react";
import { Select } from "antd";
import Axios from "axios";
import { updateUserRole } from "../../services/firebaseService/endPoints/admin/members.js";
import logger from "../../utils/logger.js";

const { Option } = Select;

const CustomDropDown = ({
  value,
  userId,
  groupData,
  userName,
  myName,
  disabled,
  required,
  name,
  className,
  tabIndex,
  dataList,
  editMemberInLocalDb,
}) => {
  const [userRole, setUserRole] = useState(value);

  useEffect(() => {
    setUserRole(value);
  }, [value]);

  const onChanged = (e) => {
    if (
      window.confirm(
        userRole === "fan"
          ? "Are you sure? Fan record will move to All Members tab."
          : "You are changing permissions for this member. Are you Sure?"
      )
    ) {
      let role = e;
      if (role === "parent-admin") {
        role = "parentAdmin";
      }
      setUserRole(e);
      editMemberInLocalDb({ id: userId, userRole: role });

      updateUserRole(groupData.id, userId, role.toString(), value)
        .then((val) => {
          if (e !== "member") {
            var bdy = {
              tit: `${groupData.groupName} permissions alert`,
              bdy: `${userName} has been granted ${role} permissions by ${myName}.`,
              image: "",
              receiverDocId: "",
              topic: "",
              gName: `${groupData.groupName}`,
              gId: `${groupData.id}`,
              gCId: `${groupData.clubId}`,
              gLId: `${groupData.leagueId}`,
              type: "general_updates",
              timestamp: "",
              authorName: "",
              authorDocId: "",
              senderName: "",
              senderDocId: "",
              matchId: "",
              cName: "",
              cType: "",
              cId: "",
              pId: "",
            };
            Axios.post(
              `${import.meta.env.VITE_GCP_BASE_URL}/sendNotificationToAdmin`,
              JSON.stringify(bdy),
              {
                headers: {
                  "content-type": "application/json",
                },
              }
            );
          }
        })
        .catch((err) => {
          logger.error("Error: ", err);
        });
    }
  };

  return (
    <div>
      <Select
        style={{ width: `150px` }}
        disabled={disabled}
        required={required}
        value={userRole}
        name={name}
        onChange={onChanged}
        className={className}
        options={
          dataList.length > 0 &&
          dataList.map((data) => {
            return { data, data };
          })
        }
        tabIndex={tabIndex || 0}
      >
        {dataList.length > 0 &&
          dataList.map((data, index) => {
            return (
              <Option key={index} value={data}>
                {data}
              </Option>
            );
          })}
      </Select>
    </div>
  );
};

export default CustomDropDown;
